import { BaseComponent } from '../../components/BaseComponent';
import * as _ from 'lodash';
// tslint:disable-next-line: no-submodule-imports
import anime from 'animejs/lib/anime.es.js';

class Animator extends BaseComponent {
  constructor(rootElement: HTMLElement) {
    super(rootElement);

    this.rootElement = rootElement;
    this.rootPath = rootElement.querySelector('.js-root-path');
    this.states = Array.from(rootElement.querySelectorAll('.js-state'));
    this.rootPathOriginalAttribute = this.rootPathAttribute;
  }

  public rootPath: SVGPathElement | null;
  public states: SVGPathElement[];
  public rootPathOriginalAttribute: string;

  public anime: any;

  public get type() {
    return this.rootElement.dataset && this.rootElement.dataset.type ? this.rootElement.dataset.type : 'autoplay';
  }

  public get loop(): number | boolean {
    const loop =
      this.rootElement.dataset && this.rootElement.dataset.loop ? Number(this.rootElement.dataset.loop) : true;
    return this.type === 'hover' || loop;
  }

  public get endDelay(): number {
    return Number(this.rootElement.dataset.endDelay) || 0;
  }

  public get rootPathAttribute() {
    return this.rootPath!.getAttribute('d') ?? '';
  }

  public get numberOfstates() {
    return Number(this.rootElement.dataset.states) || 0;
  }

  public get statePaths() {
    return this.states.map((state) => {
      return { value: state.getAttribute('d') };
    });
  }

  public get initialStatePaths() {
    return [{ value: this.rootPathAttribute }, { value: this.states[this.initialAnimateToState].getAttribute('d') }];
  }

  public get initialAnimateToState() {
    const value =
      this.rootElement!.dataset && this.rootElement!.dataset.initialAnimateToState
        ? this.rootElement!.dataset.initialAnimateToState
        : '';
    const lastState = this.states.length - 1;

    if (value) {
      if (isNaN(value as any)) {
        return value === 'first' ? 0 : lastState;
      }
      return parseInt(value, 2) - 1;
    }
    return lastState;
  }

  public animate = () => {
    this.anime = anime({
      targets: this.rootPath,
      d: this.initialStatePaths,
      easing: 'easeInOutSine',
      duration: 700,
      loop: false,
      autoplay: true,
      complete: this.loopAnimation,
    });
  }

  public loopAnimation = () => {
    this.anime = anime({
      targets: this.rootPath,
      d: this.statePaths,
      easing: 'easeInOutSine',
      duration: 600,
      loop: this.loop,
      direction: 'alternate',
      autoplay: true,
    });

    if (this.type === 'autoplay') {
      this.anime.complete = this.animateOut;
    }
  }

  public animateOut = () => {
    this.anime.pause();

    this.anime = anime({
      targets: this.rootPath,
      d: [{ value: this.rootPathAttribute }, { value: this.rootPathOriginalAttribute }],
      easing: 'easeInOutSine',
      duration: 400,
      loop: false,
      endDelay: this.endDelay,
    });

    if (this.type === 'autoplay') {
      this.anime.complete = this.animate;
    }
  }

  public init() {
    if (this.type === 'hover') {
      this.rootElement.addEventListener('mouseenter', this.animate);
      this.rootElement.addEventListener('mouseleave', this.animateOut);
    } else if (this.type === 'autoplay') {
      this.animate();
    }
  }
}

export default Animator;
